
import { useState } from 'react';

export default function ITSupportPage() {
  const [selectedPackage, setSelectedPackage] = useState('');
  const [formData, setFormData] = useState({
    fullName: '',
    phone: '',
    email: '',
    company: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitMessage, setSubmitMessage] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);
  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showCustomerToolsDropdown, setShowCustomerToolsDropdown] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await fetch('https://lbvcnepwlojmojlxmhau.supabase.co/functions/v1/send-contact-email', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          message: `${formData.message}\n\nSeçilen Paket: ${selectedPackage || 'Belirtilmemiş'}`
        }),
      });

      const result = await response.json();
      
      if (result.success) {
        setSubmitMessage('Talebiniz başarıyla gönderildi! En kısa sürede sizinle iletişime geçeceğiz.');
        setFormData({ fullName: '', phone: '', email: '', company: '', message: '' });
        setSelectedPackage('');
      } else {
        setSubmitMessage('Bir hata oluştu. Lütfen tekrar deneyin veya doğrudan arayın.');
      }
    } catch (error) {
      setSubmitMessage('Bağlantı hatası. Lütfen internet bağlantınızı kontrol edin.');
    }

    setIsSubmitting(false);
  };

  const packages = [
    {
      name: 'Temel Destek',
      description: 'Küçük işletmeler için ideal',
      features: [
        'Mesai saatleri telefon desteği',
        'E-posta ile teknik destek',
        'Uzaktan bağlantı desteği',
        'Aylık sistem kontrolü',
        'Temel güvenlik taraması',
        'Yazılım güncellemeleri',
        '48 saat yanıt süresi'
      ],
      popular: false
    },
    {
      name: 'Profesyonel Destek',
      description: 'Orta ölçekli işletmeler için',
      features: [
        '7/24 telefon ve e-posta desteği',
        'Öncelikli uzaktan destek',
        'Haftalık sistem izleme',
        'Proaktif güvenlik yönetimi',
        'Otomatik yedekleme kontrolü',
        'Performans optimizasyonu',
        '24 saat yanıt süresi',
        'Aylık raporlama'
      ],
      popular: true
    },
    {
      name: 'Kurumsal Destek',
      description: 'Büyük kuruluşlar için',
      features: [
        '7/24 premium destek hattı',
        'Özel hesap yöneticisi',
        'Gerçek zamanlı sistem izleme',
        'Gelişmiş güvenlik yönetimi',
        'Otomatik felaket kurtarma',
        'SLA garantisi (%99.9)',
        '2 saat yanıt süresi',
        'Haftalık detaylı raporlar',
        'Ücretsiz yerinde destek'
      ],
      popular: false
    }
  ];

  const supportServices = [
    {
      icon: 'ri-phone-line',
      title: '7/24 Telefon Desteği',
      description: 'Acil durumlar için kesintisiz telefon desteği hizmeti'
    },
    {
      icon: 'ri-computer-line',
      title: 'Uzaktan Destek',
      description: 'Güvenli uzaktan bağlantı ile hızlı problem çözümü'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Güvenlik Yönetimi',
      description: 'Proaktif güvenlik izleme ve tehdit analizi'
    },
    {
      icon: 'ri-database-2-line',
      title: 'Yedekleme Hizmetleri',
      description: 'Otomatik yedekleme ve veri kurtarma çözümleri'
    },
    {
      icon: 'ri-speed-up-line',
      title: 'Performans İzleme',
      description: 'Sistem performansı izleme ve optimizasyon'
    },
    {
      icon: 'ri-tools-line',
      title: 'Bakım Hizmetleri',
      description: 'Düzenli sistem bakımı ve güncellemeleri'
    }
  ];

  const testimonials = [
    {
      name: 'Mehmet Kaya',
      company: 'Kaya İnşaat',
      text: 'Nimbus\'un IT destek hizmeti sayesinde hiç sistem sorunu yaşamıyoruz. 7/24 destek gerçekten çok değerli.',
      rating: 5
    },
    {
      name: 'Ayşe Demir',
      company: 'Demir Tekstil',
      text: 'Uzaktan destek hizmeti çok hızlı ve etkili. Sorunlarımız dakikalar içinde çözülüyor.',
      rating: 5
    },
    {
      name: 'Ali Yılmaz',
      company: 'Yılmaz Otomotiv',
      text: 'Proaktif yaklaşımları sayesinde sorunlar oluşmadan önleniyor. Mükemmel hizmet!',
      rating: 5
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm sticky top-0 z-50 border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center space-x-8">
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="flex items-center space-x-3 cursor-pointer"
              >
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bilişim Logo"
                  className="h-24 w-auto"
                />
                <div className="text-lg text-gray-900">
                  Nimbus Bulut Bilişim Teknoloji ve Mühendislik
                </div>
              </button>
              
              <nav className="hidden lg:flex space-x-8">
                <div className="relative group">
                  <button
                    onClick={() => {
                      setShowServicesDropdown(!showServicesDropdown);
                      setShowCustomerToolsDropdown(false);
                    }}
                    className="flex items-center space-x-1 hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
                  >
                    <span>IT Hizmetleri</span>
                    <i
                      className={`ri-arrow-${showServicesDropdown ? 'up' : 'down'}-s-line transition-transform`}
                    ></i>
                  </button>
                  {showServicesDropdown && (
                    <div className="absolute top-full left-0 mt-2 w-[900px] bg-white rounded-lg shadow-lg border border-gray-200 py-6 z-50">
                      <div className="grid grid-cols-3 gap-8 px-8">
                        {/* IT Destek Hizmetleri */}
                        <div>
                          <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
                            IT Destek Hizmetleri
                          </h4>
                          <div className="space-y-3">
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/it-support');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-blue-600 font-semibold cursor-pointer"
                            >
                              <div className="font-medium">IT Destek & Bakım Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">7/24 IT destek ve bakım hizmetleri</div>
                            </button>
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/it-consulting');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">IT Danışmanlık Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">Profesyonel danışmanlık</div>
                            </button>
                          </div>
                        </div>

                        {/* Bulut Bilişim Hizmetleri */}
                        <div>
                          <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
                            Bulut Bilişim Hizmetleri
                          </h4>
                          <div className="space-y-3">
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/virtual-server');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Bulud Bilişim Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">Kurumsal bulut sunucu hizmetleri</div>
                            </button>
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/manged-it');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Yönetilen IT Hizmetleri</div>
                              <div className="text-sm text-gray-500 mt-1">Tüm yönetim hizmetleri</div>
                            </button>
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/migration');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Sistem Taşıma ve Geçiş Hizmetleri (Migration)</div>
                              <div className="text-sm text-gray-500 mt-1">Sunucu taşıma hizmetleri</div>
                            </button>
                          </div>
                        </div>

                        {/* Microsoft 365 Hizmetleri */}
                        <div>
                          <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wide">
                            Microsoft 365 Hizmetleri
                          </h4>
                          <div className="space-y-3">
                            <button
                              onClick={() => {
                                window.REACT_APP_NAVIGATE('/services/microsoft-365');
                                setShowServicesDropdown(false);
                              }}
                              className="w-full text-left px-4 py-3 hover:bg-gray-50 rounded-lg transition-colors text-gray-700 cursor-pointer"
                            >
                              <div className="font-medium">Microsoft 365 Geçiş ve Yönetimi</div>
                              <div className="text-sm text-gray-500 mt-1">Azure Expert hizmetleri</div>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </nav>
              
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
              >
                Başarı Hikayeleri
              </button>
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/about')}
                className="hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
              >
                Hakkımızda
              </button>
              <button
                onClick={() => window.REACT_APP_NAVIGATE('/')}
                className="hover:text-blue-600 transition-colors whitespace-nowrap text-gray-700 cursor-pointer"
              >
                SSS
              </button>
            </div>
            <div className="flex items-center space-x-4">
              <button
                onClick={() => setIsContactModalOpen(true)}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg transition-colors whitespace-nowrap cursor-pointer"
              >
                İletişim
              </button>
              <a
                href="https://www.linkedin.com/company/nimbus-bulut-bili%C5%9Fim-teknoloji-yaz%C4%B1l%C4%B1m-ve-m%C3%BChendislik-a-%C5%9F/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-700 hover:text-blue-600 transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Click outside to close dropdown */}
      {isMenuOpen && (
        <div
          className="fixed inset-0 z-40"
          onClick={() => setIsMenuOpen(false)}
        ></div>
      )}

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-20 overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center opacity-20"
          style={{
            backgroundImage: `url('https://public.readdy.ai/ai/img_res/626de26693df98062aace49184c94e3d.jpg')`,
            animation: 'slowPan 5s ease-in-out infinite alternate'
          }}
        ></div>
        <style>{`
          @keyframes slowPan {
            0% {
              transform: scale(1) translate(0, 0);
            }
            100% {
              transform: scale(1.1) translate(3%, -3%);
            }
          }
        `}</style>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              IT Destek ve Bakım Hizmetleri
            </h1>
            <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto opacity-90">
              7/24 profesyonel IT desteği ile işletmenizin teknoloji altyapısını güvence altına alın
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button 
                onClick={() => document.getElementById('packages')?.scrollIntoView({ behavior: 'smooth' })}
                className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                Paketleri İncele
              </button>
              <button 
                onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
                className="border-2 border-white text-white px-8 py-4 rounded-lg font-semibold hover:bg-white hover:text-blue-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Hemen İletişime Geç
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Kapsamlı IT Destek Hizmetleri
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              İşletmenizin teknoloji ihtiyaçlarını karşılamak için geniş bir hizmet yelpazesi sunuyoruz
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {supportServices.map((service, index) => (
              <div key={index} className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-shadow">
                <div className="w-16 h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-2xl text-blue-600`}></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">{service.title}</h3>
                <p className="text-gray-600">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Support Process */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Destek Süreci Nasıl İşler?
            </h2>
            <p className="text-xl text-gray-600">
              Hızlı ve etkili çözüm için optimize edilmiş destek sürecimiz
            </p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                1
              </div>
              <h3 className="text-lg font-semibold mb-2">İletişim</h3>
              <p className="text-gray-600">Telefon, e-posta veya destek portalı üzerinden bize ulaşın</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                2
              </div>
              <h3 className="text-lg font-semibold mb-2">Analiz</h3>
              <p className="text-gray-600">Sorununuzu analiz eder ve en uygun çözümü belirleriz</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                3
              </div>
              <h3 className="text-lg font-semibold mb-2">Çözüm</h3>
              <p className="text-gray-600">Uzaktan veya yerinde müdahale ile sorununuzu çözeriz</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center mx-auto mb-4 text-2xl font-bold">
                4
              </div>
              <h3 className="text-lg font-semibold mb-2">Takip</h3>
              <p className="text-gray-600">Çözümün etkinliğini takip eder ve raporlarız</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Packages */}
      <section id="packages" className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              IT Destek Paketleri
            </h2>
            <p className="text-xl text-gray-600">
              İhtiyacınıza uygun destek paketini seçin
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {packages.map((pkg, index) => (
              <div 
                key={index} 
                className={`bg-white rounded-xl shadow-lg p-8 relative ${pkg.popular ? 'ring-2 ring-blue-500 transform scale-105' : ''}`}
              >
                {pkg.popular && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-blue-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                      En Popüler
                    </span>
                  </div>
                )}
                
                <div className="text-center mb-8">
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{pkg.name}</h3>
                  <p className="text-gray-600 mb-4">{pkg.description}</p>
                  <div className="text-lg font-semibold text-blue-600">
                    Fiyat Teklifi Alın
                  </div>
                </div>

                <ul className="space-y-4 mb-8">
                  {pkg.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-start">
                      <i className="ri-check-line text-green-500 text-xl mr-3 mt-0.5"></i>
                      <span className="text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>

                <button 
                  onClick={() => {
                    setSelectedPackage(pkg.name);
                    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className={`w-full py-3 px-6 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer ${
                    pkg.popular 
                      ? 'bg-blue-600 text-white hover:bg-blue-700' 
                      : 'bg-gray-100 text-gray-900 hover:bg-gray-200'
                  }`}
                >
                  Paketi Seç
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* SLA Information */}
      <section className="py-20 bg-blue-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold mb-4">Hizmet Seviyesi Garantileri</h2>
            <p className="text-xl opacity-90">Müşterilerimize verdiğimiz kalite taahhütleri</p>
          </div>

          <div className="grid md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-300 mb-2">99.9%</div>
              <div className="text-lg font-semibold mb-2">Uptime Garantisi</div>
              <p className="text-blue-100">Sistem erişilebilirlik garantisi</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-300 mb-2">&lt;2h</div>
              <div className="text-lg font-semibold mb-2">Yanıt Süresi</div>
              <p className="text-blue-100">Kritik sorunlar için maksimum yanıt süresi</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-300 mb-2">7/24</div>
              <div className="text-lg font-semibold mb-2">Destek Hattı</div>
              <p className="text-blue-100">Kesintisiz teknik destek hizmeti</p>
            </div>
            <div className="text-center">
              <div className="text-4xl font-bold text-blue-300 mb-2">100%</div>
              <div className="text-lg font-semibold mb-2">Müşteri Memnuniyeti</div>
              <p className="text-blue-100">Hedeflediğimiz memnuniyet oranı</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section id="contact" className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              IT Destek Talebi Oluşturun
            </h2>
            <p className="text-xl text-gray-600">
              Uzman ekibimiz en kısa sürede sizinle iletişime geçecek
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center justify-center mb-6">
              <img
                src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                alt="Nimbus Bilişim Logo"
                className="h-16 w-auto"
              />
            </div>

            {selectedPackage && (
              <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                <p className="text-blue-800">
                  <strong>Seçilen Paket:</strong> {selectedPackage}
                </p>
              </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Ad Soyad *
                  </label>
                  <input
                    type="text"
                    required
                    value={formData.fullName}
                    onChange={(e) => setFormData({...formData, fullName: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Adınız ve soyadınız"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Telefon *
                  </label>
                  <input
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({...formData, phone: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="0555 123 45 67"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    E-posta *
                  </label>
                  <input
                    type="email"
                    required
                    value={formData.email}
                    onChange={(e) => setFormData({...formData, email: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="ornek@email.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Şirket
                  </label>
                  <input
                    type="text"
                    value={formData.company}
                    onChange={(e) => setFormData({...formData, company: e.target.value})}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                    placeholder="Şirket adınız"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Mesajınız
                </label>
                <textarea
                  rows={5}
                  value={formData.message}
                  onChange={(e) => setFormData({...formData, message: e.target.value})}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent text-sm"
                  placeholder="IT destek ihtiyaçlarınızı detaylı olarak açıklayın..."
                  maxLength={500}
                ></textarea>
                <p className="text-sm text-gray-500 mt-1">Maksimum 500 karakter</p>
              </div>

              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-600 text-white py-4 px-6 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {isSubmitting ? 'Gönderiliyor...' : 'Destek Talebi Gönder'}
              </button>

              {submitMessage && (
                <div className={`p-4 rounded-lg ${submitMessage.includes('başarıyla') ? 'bg-green-50 text-green-800 border border-green-200' : 'bg-red-50 text-red-800 border border-red-200'}`}>
                  {submitMessage}
                </div>
              )}
            </form>
          </div>
        </div>
      </section>

      {/* Customer Testimonials */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Müşteri Deneyimleri
            </h2>
            <p className="text-xl text-gray-600">
              IT destek hizmetlerimizden yararlanan müşterilerimizin görüşleri
            </p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-xl">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl"></i>
                  ))}
                </div>
                <p className="text-gray-700 mb-6 italic">"{testimonial.text}"</p>
                <div>
                  <div className="font-semibold text-gray-900">{testimonial.name}</div>
                  <div className="text-gray-600">{testimonial.company}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <a href="/" className="flex items-center space-x-3 cursor-pointer">
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bilişim Logo"
                  className="h-24 w-auto"
                />
                <div className="text-lg text-gray-900">
                  Nimbus Bulut Bilişim Teknoloji ve Mühendislik
                </div>
              </a>
              <div className="flex items-center space-x-3 mb-6">
                <img
                  src="https://static.readdy.ai/image/ceb81aa66be17b1fc7ed204b9f91964c/7b7be6e694aa19d5c5f7abd74de9f9de.png"
                  alt="Nimbus Bilişim Logo"
                  className="h-24 w-auto"
                />
                <div className="text-lg">Nimbus Bulut Bilişim Teknoloji ve Mühendislik</div>
              </div>
              <p className="text-gray-400 mb-4">
                Güvenilir bulut bilişim ve IT çözümleri
              </p>
              <div className="flex space-x-4">
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
                <a href="#" className="text-gray-400 hover:text-white transition-colors">
                  <i className="ri-linkedin-fill text-xl"></i>
                </a>
              </div>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Hizmetler</h4>
              <ul className="space-y-2">
                <li>
                  <button 
                    onClick={() => window.REACT_APP_NAVIGATE('/services/virtual-server')}
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    Sanal Sunucu
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => window.REACT_APP_NAVIGATE('/services/microsoft-365')}
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    Microsoft 365
                  </button>
                </li>
                <li>
                  <span className="text-white">IT Destek</span>
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">İletişim</h4>
              <ul className="space-y-2 text-gray-400">
                <li className="flex items-center">
                  <i className="ri-phone-line mr-2"></i>
                  +90 555 123 45 67
                </li>
                <li className="flex items-center">
                  <i className="ri-mail-line mr-2"></i>
                  info@nimbusbilisim.com
                </li>
                <li className="flex items-center">
                  <i className="ri-map-pin-line mr-2"></i>
                  İstanbul, Türkiye
                </li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-lg font-semibold mb-4">Destek</h4>
              <ul className="space-y-2 text-gray-400">
                <li>7/24 Teknik Destek</li>
                <li>Canlı Sohbet</li>
                <li>Uzaktan Yardım</li>
                <li>Dokümantasyon</li>
              </ul>
            </div>
          </div>
          
          <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
            <p>&copy; 2024 Nimbus Bulut Bilişim. Tüm hakları saklıdır. | 
              <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors ml-1">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
